<!-- 顶栏消息图标 -->
<template>
    <el-popover
            :width="330"
            trigger="click"
            v-model="visible"
            class="ele-notice-group"
            transition="el-zoom-in-top"
            popper-class="ele-notice-pop">
        <div slot="reference" class="ele-notice-group">
            <el-badge :value="num" :hidden="!num">
                <i class="el-icon-bell" style="color: white;font-size: 20px;"></i>
            </el-badge>
        </div>
        <div class="ele-notice-list ele-scrollbar-mini">
            <div v-for="(item, index) in news" :key="index" class="ele-notice-item" @click="getmsg(item)">
                <div class="ele-cell ele-notice-item-wrapper">
                    <div class="ele-cell-content">
                        <div class="justify-sbetween">
                            <div class="ele-elip xxbt">{{ item.headline }}</div>
                            <div :style="{color:['','#649DE7','#DE3045','#30C197'][item.messageType],
                            background:['','rgba(100,157,231,0.1)','rgba(255,0,0,0.1)','rgba(48,193,151,0.1)'][item.messageType]}" class="bttype">
                                {{['','系统消息','告警消息','物流消息'][item.messageType]}}
                            </div>
                        </div>
                        <div class="ele-text-secondary ele-elip">{{ item.createTime }}</div>
                    </div>
                    <div v-if="item.readFlag==0" style="color: red">●</div>
                </div>

                <el-divider/>
            </div>
        </div>
        <div v-if="news.length" class="ele-cell ele-notice-actions">
            <div class="ele-cell-content" @click="more">查看更多</div>
        </div>
        <el-empty v-if="news.length<=0" description="暂无新通知"/>
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                :append-to-body="true"
                width="30%"
                :before-close="handleClose">
            <span v-html="text"></span>
        </el-dialog>
    </el-popover>
</template>

<script>
    import {getSysMessageSendById} from '@/api/information'
    import { mapGetters } from 'vuex'

    export default {
        name: 'EleNotice',
        computed: {
            ...mapGetters([
                'news',
                'num'
            ])
        },
        data() {
            return {
                visible: false,
                active: 'notice',
                title:'',
                text:'',
                dialogVisible:false,
                notice: [],
                message: [],
                todo: [],
                queryParams: {
                    pageSize:10,
                    pageNum:1
                },
            };
        },
        mounted() {
            this.getinfo()
        },
        created() {

        },
        methods: {
            getinfo(){
                this.$store.dispatch("GetNews",'111').then((res) => {

                })
            },
            //查看信息
            getmsg(e){
                getSysMessageSendById({sendId:e.sendId}).then(({data})=>{
                    this.title=data.headline
                    this.text=data.content
                    this.dialogVisible=true
                    this.getinfo()
                })
            },
            handleClose(){
                this.dialogVisible=false
            },
            /* 查看更多 */
            more() {
                this.visible=false
                this.$router.push({
                    path: `/detail/informations`,
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ele-notice-group {
        display: block;

        .el-badge {
            line-height: 1;
            display: block;
        }
    }

    /* 消息通知pop */
    .ele-notice-pop {
        padding: 0 !important;

        /* tab */
        .el-tabs__nav-scroll {
            text-align: center;
        }

        .el-tabs__nav {
            float: none;
            display: inline-block;
        }

        .el-tabs__item {
            height: 44px;
            line-height: 44px;
            padding: 0 20px !important;
        }

        /* 空视图 */
        .ele-empty {
            padding: 100px 0;
        }
    }

    /* 列表 */
    .ele-notice-list {
        padding-top: 8px;
        max-height: 360px;
        overflow: auto;
    }

    .ele-notice-item {
        .ele-notice-item-wrapper {
            padding: 12px 15px;
            transition: background-color .2s;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            &:hover {
                background-color: hsla(0, 0%, 60%, .05);
            }
        }

        .ele-text-secondary {
            margin-top: 5px;
            font-size: 13px;
        }

        .ele-cell-desc {
            margin-top: 3px !important;
            font-size: 12px !important;
        }
    }

    .ele-notice-item-icon {
        width: 32px;
        height: 32px;
        line-height: 32px !important;
        color: #FFF;
        font-size: 16px;
        background-color: #60B2FC;
        border-radius: 50%;
        text-align: center;


        &.el-icon-s-check {
            background-color: #F5686F;
        }

        &.el-icon-video-camera {
            background-color: #7CD734;
        }

        &.el-icon-s-claim {
            background-color: #FAAD14;
        }

        &.el-icon-message-solid {
            background-color: #2BCACD;
        }
    }

    /* 操作按钮 */
    .ele-notice-actions > .ele-cell-content {
        line-height: 42px;
        text-align: center;
        cursor: pointer;

        &:hover {
            background-color: hsla(0, 0%, 60%, .05);
        }
    }
    ::v-deep .el-divider--horizontal{
        margin: 0 !important;
    }
    .xxbt{
        width: 60px;
        overflow :hidden; //超出的文本隐藏
        text-overflow :ellipsis; //溢出用省略号显示
        white-space :nowrap; //溢出不换行
    }
    .bttype{
        padding: 3px 8px;
        font-size: 12px;
        border-radius: 5px;
    }
</style>
